import { Fragment } from 'react';
import styled from 'styled-components';
import { GridLayoutLegacy } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { meta } from '../../constants';
import { getClassName } from '../helpers';
import { Item } from '../templates';

export const GridLayout = () => {
  const { files, clickAction } = useSettings();

  return (
    <Component>
      <GridLayoutLegacy
        appAlias={meta.alias}
        gutter={{
          h: 24,
          v: 24
        }}
        columnBasis={220}
      >
        {files.map((item) => (
          <Fragment key={item.id}>
            {(clickAction === 'newTab' || clickAction === 'download') && (
              <Item item={item} />
            )}
          </Fragment>
        ))}
      </GridLayoutLegacy>
    </Component>
  );
};

const Component = styled.div.attrs({
  className: getClassName('grid-layout', 'component')
})`
  overflow: hidden;
`;
